import {
  AreaChart,
  BarChart3,
  Gauge,
  Grid3x3,
  Hash,
  LineChart,
  PieChart,
  Table2,
  type LucideIcon,
} from 'lucide-react';
import type { Aggregation, DateInterval, Visualization } from '@contracts';

/** Etiqueta + icono por tipo de visualización. */
export const VIZ_META: Record<Visualization, { label: string; Icon: LucideIcon }> = {
  kpi: { label: 'Métrica', Icon: Hash },
  bar: { label: 'Barras', Icon: BarChart3 },
  line: { label: 'Línea', Icon: LineChart },
  area: { label: 'Área', Icon: AreaChart },
  pie: { label: 'Pastel', Icon: PieChart },
  donut: { label: 'Dona', Icon: PieChart },
  table: { label: 'Tabla', Icon: Table2 },
  heatmap: { label: 'Heatmap', Icon: Grid3x3 },
  gauge: { label: 'Indicador', Icon: Gauge },
  split: { label: 'Más / Menos', Icon: PieChart },
  decorative: { label: 'Decorativo', Icon: Hash },
};

export const STEPS = ['Datos', 'Visual', 'Apariencia'];

export const AGGS: { value: Aggregation; label: string }[] = [
  { value: 'count', label: 'Conteo' },
  { value: 'sum', label: 'Suma' },
  { value: 'avg', label: 'Promedio' },
];

export const INTERVALS: { value: DateInterval; label: string }[] = [
  { value: 'day', label: 'Día' },
  { value: 'week', label: 'Semana' },
  { value: 'month', label: 'Mes' },
  { value: 'quarter', label: 'Trimestre' },
  { value: 'year', label: 'Año' },
];
